import validators from '@utils/validators';

const validate = (values) => {
    const errors ={};

    Object.assign(errors, validators.required(values.client, 'client'));

    if (values.client) {
        Object.assign(errors, validators.required(values.tunnel, 'tunnel'));
    }

    return errors;
};

export default validate;
